import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import ReadMore from '../../../../components/ReadMore';

const CandidateInterviewDataWidget = props => {
  const { data, onClickButton } = props;

  const isEmpty = useMemo(
    () =>
      !(
        data &&
        data.hasOwnProperty('About') &&
        data.hasOwnProperty('Characteristic') &&
        data.hasOwnProperty('Compensation')
      ),
    [data]
  );

  const isEditable = onClickButton && typeof onClickButton === 'function';

  return !isEmpty || isEditable ? (
    <div className="sidebar__widget candidate-interview-data-widget">
      <h4 className="sidebar__title">Candidate Interview Data</h4>
      {!isEmpty && (
        <>
          <div className="candidate-interview-data-widget__block">
            <h5 className="candidate-interview-data-widget__block-title">
              Tell us about yourself and career goals
            </h5>
            <ReadMore
              styles={{ fontSize: '.8571rem' }}
              text={data.About}
              readMoreCharacterLimit={320}
            />
          </div>
          <div className="candidate-interview-data-widget__block">
            <h5 className="candidate-interview-data-widget__block-title">
              Greatest Strength & Greatest Weakness
            </h5>
            <ReadMore
              styles={{ fontSize: '.8571rem' }}
              text={data.Characteristic}
              readMoreCharacterLimit={320}
            />
          </div>
          <div className="candidate-interview-data-widget__block">
            <h5 className="candidate-interview-data-widget__block-title">
              Compensation Expectations
            </h5>
            <ReadMore
              styles={{ fontSize: '.8571rem' }}
              text={data.Compensation}
              readMoreCharacterLimit={320}
            />
          </div>
        </>
      )}
      {!!data && !!data.UpdatedAt && (
        <div className="candidate-interview-data-widget__updated-at">
          Last updated: {data.UpdatedAt}
        </div>
      )}
      {isEditable && (
        <BasicButton
          btnWidth={150}
          btnHeight={35}
          btnFontSize="0.8571rem"
          btnFontWeight={600}
          btnText={isEmpty ? 'Add' : 'Edit'}
          btnArrow={false}
          btnBg="#fff"
          btnHoverBg="#f40"
          controlFunc={onClickButton}
        />
      )}
    </div>
  ) : null;
};

CandidateInterviewDataWidget.propTypes = {
  data: PropTypes.shape({
    About: PropTypes.string,
    Characteristic: PropTypes.string,
    Compensation: PropTypes.string,
  }),
  onClickButton: PropTypes.func,
};

export default CandidateInterviewDataWidget;
